import React, { useState, useEffect } from "react";

const ToggleSwitch = ({ checked, onChange, label, description }) => (
  <div className="settings-item">
    <div className="settings-item-info">
      <div className="settings-item-label">{label}</div>
      {description && <div className="settings-item-description">{description}</div>}
    </div>
    <div className="settings-item-control">
      <div className={`toggle-switch ${checked ? "active" : ""}`} onClick={() => onChange(!checked)}>
        <div className="toggle-switch-slider"></div>
      </div>
    </div>
  </div>
);

const SelectSetting = ({ value, onChange, options, label, description }) => (
  <div className="settings-item">
    <div className="settings-item-info">
      <div className="settings-item-label">{label}</div>
      {description && <div className="settings-item-description">{description}</div>}
    </div>
    <div className="settings-item-control">
      <select className="settings-select" value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  </div>
);

const PrivacySettings = ({ settings, onUpdate, showToast }) => {
  const [localSettings, setLocalSettings] = useState(settings || {});

  useEffect(() => {
    setLocalSettings(settings || {});
  }, [settings]);

  const handleUpdate = async (key, value) => {
    const updated = { ...localSettings, [key]: value };
    setLocalSettings(updated);
    try {
      await onUpdate(updated);
    } catch (error) {
      setLocalSettings(localSettings);
    }
  };

  return (
    <div>
      <div className="settings-header">
        <h1>Privacidade</h1>
        <p>Controle quem pode ver suas informações e interagir com você</p>
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">👁️ Visibilidade do Perfil</h3>
        
        <SelectSetting
          value={localSettings.profileVisibility || "public"}
          onChange={(val) => handleUpdate("profileVisibility", val)}
          options={[
            { value: "public", label: "Público" },
            { value: "friends", label: "Apenas Amigos" },
            { value: "private", label: "Privado" },
          ]}
          label="Quem pode ver seu perfil"
          description="Controle quem pode acessar seu perfil"
        />

        <ToggleSwitch
          checked={localSettings.showEmail !== false}
          onChange={(val) => handleUpdate("showEmail", val)}
          label="Mostrar email"
          description="Permitir que outros vejam seu email"
        />

        <ToggleSwitch
          checked={localSettings.showPhone !== false}
          onChange={(val) => handleUpdate("showPhone", val)}
          label="Mostrar telefone"
        />

        <ToggleSwitch
          checked={localSettings.showBirthday !== false}
          onChange={(val) => handleUpdate("showBirthday", val)}
          label="Mostrar aniversário"
        />

        <ToggleSwitch
          checked={localSettings.showFriendsList !== false}
          onChange={(val) => handleUpdate("showFriendsList", val)}
          label="Mostrar lista de amigos"
        />

        <ToggleSwitch
          checked={localSettings.showFollowers !== false}
          onChange={(val) => handleUpdate("showFollowers", val)}
          label="Mostrar seguidores"
        />

        <ToggleSwitch
          checked={localSettings.searchable !== false}
          onChange={(val) => handleUpdate("searchable", val)}
          label="Permitir que me encontrem na busca"
        />
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">💬 Interações</h3>

        <SelectSetting
          value={localSettings.whoCanMessageMe || "everyone"}
          onChange={(val) => handleUpdate("whoCanMessageMe", val)}
          options={[
            { value: "everyone", label: "Todos" },
            { value: "friends", label: "Apenas Amigos" },
            { value: "nobody", label: "Ninguém" },
          ]}
          label="Quem pode me enviar mensagens"
        />

        <SelectSetting
          value={localSettings.whoCanCallMe || "friends"}
          onChange={(val) => handleUpdate("whoCanCallMe", val)}
          options={[
            { value: "everyone", label: "Todos" },
            { value: "friends", label: "Apenas Amigos" },
            { value: "nobody", label: "Ninguém" },
          ]}
          label="Quem pode me ligar"
        />

        <SelectSetting
          value={localSettings.whoCanSeeMyPosts || "public"}
          onChange={(val) => handleUpdate("whoCanSeeMyPosts", val)}
          options={[
            { value: "public", label: "Público" },
            { value: "friends", label: "Apenas Amigos" },
            { value: "private", label: "Privado" },
          ]}
          label="Quem pode ver meus posts"
        />

        <SelectSetting
          value={localSettings.whoCanCommentOnMyPosts || "everyone"}
          onChange={(val) => handleUpdate("whoCanCommentOnMyPosts", val)}
          options={[
            { value: "everyone", label: "Todos" },
            { value: "friends", label: "Apenas Amigos" },
            { value: "nobody", label: "Ninguém" },
          ]}
          label="Quem pode comentar nos meus posts"
        />

        <ToggleSwitch
          checked={localSettings.allowTagging !== false}
          onChange={(val) => handleUpdate("allowTagging", val)}
          label="Permitir marcações"
          description="Outros podem marcar você em posts e fotos"
        />

        <ToggleSwitch
          checked={localSettings.allowMentions !== false}
          onChange={(val) => handleUpdate("allowMentions", val)}
          label="Permitir menções"
        />

        <ToggleSwitch
          checked={localSettings.allowFriendRequests !== false}
          onChange={(val) => handleUpdate("allowFriendRequests", val)}
          label="Aceitar solicitações de amizade"
        />
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">🌐 Status e Atividade</h3>

        <ToggleSwitch
          checked={localSettings.showOnlineStatus !== false}
          onChange={(val) => handleUpdate("showOnlineStatus", val)}
          label="Mostrar status online"
          description="Outros podem ver quando você está online"
        />

        <ToggleSwitch
          checked={localSettings.showActivityStatus !== false}
          onChange={(val) => handleUpdate("showActivityStatus", val)}
          label="Mostrar status de atividade"
          description="Mostrar quando você está digitando ou leu mensagens"
        />
      </div>
    </div>
  );
};

export default PrivacySettings;
